import { $ } from '../lib/dom.js';
import { esc } from '../lib/escape.js';
import { read } from '../lib/store.js';

export function renderFaq() {
  const root = $('#faq-list');
  if (!root) return;
  const wrap = document.createElement('div');
  read('faq').forEach(f => {
    const d = document.createElement('details');
    d.innerHTML = `<summary><span class="q">${esc(f.q)}</span><span class="plus">+</span></summary><div class="a">${esc(f.a)}</div>`;
    wrap.appendChild(d);
  });
  root.appendChild(wrap);
}
